// extracted by mini-css-extract-plugin
export var active = "_6n-7";
export var container = "_6n-0";
export var evenWidth = "_6n-4";
export var large = "_6n-5";
export var outlet = "_6n-8";
export var slide = "_6n-2";
export var small = "_6n-6";
export var tab = "_6n-3";
export var tabs = "_6n-1";